import { useState } from 'react';
import { Box, Stack, Text, TextField, RadioGroup, Radio } from '@customerio/pluma-components/react';

interface ObjectTypeFilterProps {
  value: string;
  onChange: (value: string) => void;
  options: Array<{ value: string; label: string }>;
}

export function ObjectTypeFilter({ value, onChange, options }: ObjectTypeFilterProps) {
  const [searchQuery, setSearchQuery] = useState('');

  // Filter options based on search query (trim whitespace for better matching)
  const trimmedQuery = searchQuery.trim();
  const filteredOptions =
    trimmedQuery === ''
      ? options
      : options.filter((option) => option.label.toLowerCase().includes(trimmedQuery.toLowerCase()));

  return (
    <Box p="300">
      <Stack gap="200">
        {/* Note: Using onInput instead of onChange is required for TextField to work correctly
            in DataTable filter popovers. onChange causes the input to become unresponsive. */}
        <TextField
          value={searchQuery}
          onInput={(e) => setSearchQuery(e.target.value)}
          placeholder="Search object types..."
          label="Search object types"
        />
        <Box style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {filteredOptions.length > 0 ? (
            <RadioGroup value={value ?? ''} onChange={onChange} label="Object Type Options">
              {filteredOptions.map((option) => (
                <Radio key={option.value} label={option.label} value={option.value} />
              ))}
            </RadioGroup>
          ) : (
            <Text size="s" color="subtle">
              No object types found
            </Text>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
